(function () {
  'use strict';

  var id = 'spider',
    spiderMeasures = null;

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory(id + '.Utils', ['$filter', '$q', '$sanitize', 'CardQueryResource', 'QueryES', 'wsColors', 'AggregationUtils', 'ChartUtils', function ($filter, $q, $sanitize, CardQueryResource, QueryES, wsColors, AggUtils, ChartUtils) {
    return {
      fetchData: function fetchData(cfg) {
        if (cfg === null) {
          return $q.when(null);
        }
        cfg = cfg || {};
        var path = "/spider/data",
          params = cfg.params;

        // We don't show any rows for top level spider chart views,
        // so avoid having them in the payload by limiting to 1 row.
        if (cfg.topLevelOnly) {
          params = {
            "_limit": 1
          };

          // Special case for preview, to minimize number of preview requests,
          // make this agree with detail preview query...
          if (cfg.cardToPreview) {
            params = {
              "_limit": 10,
              "_offset": 0,
              "order_by": "dimension[0].label"
            };
          }
        }
        return CardQueryResource.getWithProgress(path, cfg.cardId, params, cfg.cardToPreview, 'spider-' + cfg.cardId);
      },
      getStatementDownloadUrl: function getStatementDownloadUrl(cardId) {
        return QueryES.queryExportUrl(cardId, true, id);
      },
      getSpiderChart: function getSpiderChart(data, config, cfg) {
        var normalize = config.scalePerMeasure,
          chartMin = normalize ? 0 : cfg.range.min,
          chartMax = normalize ? 1.0 : cfg.range.max,
          chart,
          getFiniteValueOrDefault = function getFiniteValueOrDefault(m, def) {
            // if defined, return numeric value m.value, else default value (if defined), else 0
            var value = m && m.value && parseFloat(m.value);
            if (_.isFinite(value)) {
              return value;
            }
            if (_.isFinite(def)) {
              return def;
            }
            return 0;
          };

        // unless normalizing, check measure min/max for override of range min/max
        if (!normalize) {
          _.forEach(config.measures, function (m, i) {
            if (config.hiddenMeasures && config.hiddenMeasures.indexOf(i) !== -1) {
              return;
            }
            var measureMin = getFiniteValueOrDefault(m.min, chartMin),
              measureMax = getFiniteValueOrDefault(m.max, chartMax);

            // this check allows for measureMax < measureMin
            chartMin = Math.min(chartMin, measureMin, measureMax);
            chartMax = Math.max(chartMax, measureMin, measureMax);
          });
        }
        chart = {
          chart: {
            polar: true,
            type: 'area',
            spacing: [0, 35, 0, 35]
          },
          plotOptions: {
            area: {
              fillOpacity: 0.15
            },
            series: {
              events: {
                legendItemClick: function legendItemClick() {
                  return false;
                }
              }
            }
          },
          credits: {
            enabled: false
          },
          title: {
            text: null
          },
          xAxis: {
            labels: {
              distance: 10
            },
            tickmarkPlacement: 'on',
            lineWidth: 0,
            categories: _.chain(config.measures).filter(function (m, i) {
              return (config.hiddenMeasures || []).indexOf(i) === -1;
            }).map(function (m) {
              return $sanitize(m.name);
            }).value()
          },
          yAxis: {
            lineWidth: 0,
            allowDecimals: config.displayAxisDecimals,
            showLastLabel: true,
            endOnTick: true,
            labels: {
              enabled: !normalize // labels not needed on normalized chart
            },
            min: chartMin,
            max: chartMax,
            tickAmount: 5
          },
          info: {
            scalePerMeasure: normalize,
            min: chartMin,
            max: chartMax,
            filter: $filter('number')
          },
          tooltip: {
            headerFormat: '<div class="watershed-tooltip"><table><thead><tr><th>{point.x}</th></tr></thead>',
            pointFormatter: function pointFormatter() {
              var normValue = '';
              if (normalize) {
                normValue = '<td align="right" style="padding-left: 5px"> (' + (this.y * 100).toFixed(0) + '%)</td>';
              }
              return '<tr style="color:' + this.series.color + '">' + '<td>' + this.series.name + ':</td>' + '<td align="right">' + this.displayValue + '</td>' + normValue + '</tr>';
            },
            footerFormat: '</table></div>',
            shared: true
          },
          legend: {
            enabled: true,
            align: 'center',
            verticalAlign: 'bottom',
            layout: 'horizontal'
          },
          series: []
        };
        var allDurations = true;

        //sort the data so the average and benchmark come first
        data = _.sortBy(data, function (d) {
          return d.name;
        });

        //count the number of 'benchmark series'
        var benchmarks = _.chain(data).first(3).reduce(function (count, d) {
          return count + (d.name ? 1 : 0);
        }, 0).value();
        chart.series = _.map(data, function (d, di) {
          return {
            name: $sanitize(d.name || AggUtils.getDimensionDisplay(d.values[0], config.dimensions[0])),
            color: ChartUtils.getSeriesColor(config, di),
            data: _.chain(d.aggregations).map(function (a, i) {
              var val = angular.isDefined(a.avg) ? a.avg : angular.isDefined(a.value) ? a.value : null;
              var scaledValue = parseFloat(val);

              // if normalize, clip using measure.min/max & scale
              if (normalize && _.isFinite(scaledValue)) {
                var measure = d.measures[i],
                  stats = d.stats[i],
                  lowerLimit = getFiniteValueOrDefault(measure && measure.min || 0, stats ? stats.min : 0),
                  upperLimit = getFiniteValueOrDefault(measure && measure.max || 1, stats ? stats.max : 1);

                // limit value
                scaledValue = lowerLimit < upperLimit ? Math.min(upperLimit, Math.max(lowerLimit, scaledValue)) : Math.min(lowerLimit, Math.max(upperLimit, scaledValue));

                //scale the value that we put on the chart
                if (upperLimit - lowerLimit !== 0) {
                  scaledValue = (scaledValue - lowerLimit) / (upperLimit - lowerLimit);
                } else {
                  scaledValue = 1.0;
                }
              }
              if (!AggUtils.isDurationBasedMeasure(d.measures[i])) {
                allDurations = false;
              }
              if (d.name === "Average") {
                val = _.isNumber(val) ? Math.round(parseFloat(val), 2) : null;
              }
              return {
                displayValue: AggUtils.getMeasureValueDisplay({
                  value: val
                }, d.measures[i]),
                y: scaledValue
              };
            }).filter(function (a, i) {
              return (config.hiddenMeasures || []).indexOf(i) === -1;
            }).value()
          };
        });

        //add blank series so that the first 3 colors are reserved for the benchmark series
        for (var i = 0; i < 3 - benchmarks; i++) {
          chart.series.splice(benchmarks, 0, {
            name: '',
            showInLegend: false
          });
        }

        // Only use a time based axis if all of the measures are time based.
        // This does look terrible when using a mix of measures and exact axis.
        // We should tell people to use normalized axis when mixing measures.
        if (allDurations) {
          chart.yAxis = {
            id: 'duration',
            allowDecimals: false,
            title: 'Time',
            opposite: true,
            labels: {
              formatter: function formatter() {
                return $filter('compactTime')(this.value);
              }
            }
          };
        }
        return chart;
      },
      hasBenchmark: function hasBenchmark(measures) {
        return _.any(measures, function (m) {
          return m.benchmark;
        });
      }
    };
  }]).
  // This is essentially initialization logic and for us it's primarily used here to append additional
  // routes for this specific card.
  config(['$routeProvider', function ($routeProvider) {
    // Add routes
    $routeProvider.when('/spider/:cardId', {
      templateUrl: 'modules/app/spider/spider-detail.html',
      controller: id + ".Detail",
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    }).when('/spider/:cardId/top', {
      templateUrl: 'modules/app/spider/spider-card.html',
      resolve: {
        cardLoader: ['CardLoader', function (CardLoader) {
          return CardLoader.loadCards();
        }]
      }
    });
  }]).run(['CardIconMap', function (CardIconMap) {
    CardIconMap.register({
      "spider": "spider"
    });
  }]).controller(id + ".CardConfiguration", ['$controller', '$scope', function ($controller, $scope) {
    $scope.tempMeasures = spiderMeasures;
    $scope.templateType = "spider";
    $controller("AggregationCardConfiguration", {
      $scope: $scope
    });
    $scope.spiderHelpText = {
      helpTitle: 'Spider',
      detailText: "In the Spider section, you'll choose how you want to group data (in the Organized menu) " + "and what measures you'll want to see (using the Measures menu). Choose an option in the Organized menu " + "first, and then select as many measures as you'd like by choosing them in the dropdown and clicking " + "Add Measure. Remove a measure by clicking the X next to a selected measure. We suggest choosing at least 3 measures."
    };
    $scope.$watch("workingConfig.scalePerMeasure", _.debounce(function () {
      $scope.updateCardWithWorkingConfig();
    }, 100), true);
  }]).controller(id + ".Card", ['$q', '$routeParams', '$scope', 'AggregationUtils', 'CardRegistry', 'ChartUtils', id + '.Utils', 'wsEventNames', 'ReportValidationService', function ($q, $routeParams, $scope, AggUtils, CardRegistry, ChartUtils, Utils, wsEvents, ReportValidationService) {
    // For use with /top route when embedding
    if (!$scope.cardId && $routeParams.cardId) {
      $scope.cardId = $routeParams.cardId;
    }
    $scope.config = CardRegistry.get($scope.cardId).configuration;
    $scope.defaultSummary = 'Spider chart of measures organized by ' + AggUtils.getDimensionInSentence($scope.config.dimensions[0], true) + '.';
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.noDataMsg = validation.message;
      return;
    }
    var fetchCfg = {
      cardId: $scope.cardId,
      cardToPreview: $scope.cardToPreview,
      topLevelOnly: true
    };
    Utils.fetchData(fetchCfg).then(function (r) {
      // Advertise that the preview loaded, with the preview data
      if ($scope.cardToPreview) {
        $scope.$emit(wsEvents.card.preview.loaded, r);
      }
      var data = r.results[0].result.data,
        stats = r.results[0].result.stats,
        measures = $scope.config.measures;
      var overlayConfig = $scope.config.overlay,
        overlayStats = null,
        overlayMeasures = null,
        overlayName = null;

      // separate overlayData from returned data
      if (overlayConfig) {
        overlayMeasures = overlayConfig.measures;
        overlayName = overlayConfig.name || 'Overlay';
        overlayStats = stats.slice(-overlayMeasures.length);
        stats = stats.slice(0, overlayMeasures.length);
      }
      var defaultRange = {
        min: 0
      };
      var chartRange = ChartUtils.getRange(stats, measures, defaultRange);

      // Create chartData with Average series
      var chartData = [{
        name: "Average",
        values: [{
          value: -1,
          label: "Average"
        }],
        aggregations: _.map(stats, function (s) {
          return {
            value: _.isNumber(s.avg) ? parseFloat(s.avg).toFixed(2) : null
          };
        }),
        measures: measures,
        stats: stats
      }];

      // add overlay Average series (if it exists)
      if (overlayConfig) {
        chartData.push({
          name: overlayName + ' Average',
          aggregations: overlayStats,
          measures: overlayMeasures,
          stats: overlayStats
        });
      }

      // add main data benchmark series (if it exist)
      if (Utils.hasBenchmark(measures)) {
        chartData.push({
          name: 'Benchmark',
          aggregations: _.map(measures, function (m) {
            return {
              value: m.benchmark && parseFloat(m.benchmark.value) || null
            };
          }),
          measures: measures,
          stats: stats
        });
      }

      // add overlay benchmark series (if it exists)
      if (overlayConfig && Utils.hasBenchmark(overlayMeasures)) {
        chartData.push({
          name: overlayName + ' Benchmark',
          aggregations: _.map(overlayMeasures, function (m) {
            return {
              value: m.benchmark && parseFloat(m.benchmark.value) || null
            };
          }),
          measures: overlayMeasures,
          stats: overlayStats
        });
      }

      // get spider chart
      var cfg = {
        range: chartRange,
        stats: stats
      };
      $scope.spiderChart = Utils.getSpiderChart(chartData, $scope.config, cfg);
      $scope.hasData = data.length > 0;
    });
  }]).controller(id + ".Detail", ['$q', '$routeParams', '$scope', '$timeout', 'AggregationUtils', 'CardQueryResource', 'CardRegistry', 'CardUtils', 'Utils', 'ChartUtils', id + '.Utils', 'wsEventNames', 'ReportValidationService', 'uiGridConstants', function ($q, $routeParams, $scope, $timeout, AggUtils, CardQueryResource, CardRegistry, CardUtils, CentralUtils, ChartUtils, Utils, wsEventNames, ReportValidationService, uiGridConstants) {
    CardUtils.setNavElements($scope, $routeParams.cardId, $routeParams.cardId);
    $scope.cardId = $routeParams.cardId;
    $scope.card = CardRegistry.get($scope.cardId);
    $scope.config = $scope.card.configuration;
    $scope.sortConfig = AggUtils.sortConfig($scope.config);
    var gridRowHeight = 50;
    var validation = ReportValidationService.validate($scope.cardId);
    if (validation.hasErrors) {
      $scope.hasData = false;
      $scope.gridOptions = {};
      $scope.noDataMsg = validation.message;
      return;
    }

    //display util functions

    $scope.getMeasureValueDisplay = AggUtils.getMeasureValueDisplay;
    var measureDisplayNames = _.chain($scope.config.measures).filter(function (m, i) {
      return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
    }).pluck('name').value();

    // These measure names aren't actually visible and could be something simpler, but chose to retain
    // the display name but remove non-alphabetic chars and add an index at the end for human readability.
    // This fixed a bug where column names with "." or "(" wouldn't render WSLRS-5520.
    var measureNames = _.chain($scope.config.measures).filter(function (m, i) {
      return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
    }).map(function (m, idx) {
      return m.name.replace(/[^a-zA-Z0-9]/g, '') + "_" + idx;
    }).value();

    //data to place on the spider chart
    var idsOnChart = [];
    $scope.dataOnChart = [];
    $scope.$watchCollection('dataOnChart', function () {
      if (_.isEmpty($scope.dataOnChart)) {
        return;
      }
      var cfg = {
        range: $scope.chartRange,
        stats: $scope.stats
      };
      $scope.spiderChart = Utils.getSpiderChart($scope.dataOnChart, $scope.config, cfg);
    });
    var getUniqueId = function getUniqueId(d) {
      return d.values[0].value + ':' + d.values[0].label;
    };
    $scope.addToChart = function addToChart(d) {
      idsOnChart.push(getUniqueId(d));
      $scope.dataOnChart.push(d);
    };
    $scope.removeFromChart = function removeFromChart(d) {
      var i = idsOnChart.indexOf(getUniqueId(d));
      if (i > -1) {
        idsOnChart.splice(i, 1);
        $scope.dataOnChart.splice(i, 1);
      }
    };
    $scope.isOnChart = function isOnChart(d) {
      return idsOnChart.indexOf(getUniqueId(d)) >= 0;
    };
    $scope.checkedBox = function checkedBox(d) {
      if ($scope.isOnChart(d)) {
        $scope.removeFromChart(d);
      } else {
        $scope.addToChart(d);
      }
    };

    //Set up grid-ui
    //table header
    var dimensionLabels = AggUtils.getDimensionLabels({
      config: $scope.config,
      context: 'detailView'
    });
    var columns = [{
      field: 'label',
      displayName: CentralUtils.capitalizeEachWord(dimensionLabels[0]),
      cellTemplate: '<div>{{row.entity.label}}</div>',
      width: '180'
    }].concat(_.map(measureNames, function (name, idx) {
      return {
        field: name,
        width: '100',
        displayName: measureDisplayNames[idx]
      };
    }));
    columns.push({
      displayName: 'Add To Chart',
      field: 'onChart',
      width: '100',
      enableSorting: false,
      cellTemplate:
      //'<input type="checkbox" ng-model="row.entity.onChart" ' +
      '<input type="checkbox" ng-checked="grid.appScope.isOnChart(row.entity.dataPoint)" ' + 'ng-click="grid.appScope.checkedBox(row.entity.dataPoint)">'
    });

    // Build a map of dimension / measure field -> sort directive (used in "order_by" param)
    var sortDirectives = _.extend({
      'label': 'dimension[0].label'
    }, _.object(measureNames, _.map(measureNames, function (name, index) {
      return 'measure[' + index + '].value';
    })));

    //options for grid ui
    $scope.gridOptions = {
      columnDefs: columns,
      rowHeight: gridRowHeight,
      enableVerticalScrollbar: 0,
      enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
      useExternalPagination: true,
      useExternalSorting: true,
      style: {
        "min-height": "400px"
      },
      onRegisterApi: function onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        $scope.gridApi.core.on.sortChanged($scope, function (grid, sortColumns) {
          if (sortColumns.length <= 0) {
            return;
          }
          var sortColumn = sortColumns[0],
            ascending = sortColumn.sort.direction === "asc",
            sortDirective = sortDirectives[sortColumn.field];
          if (!ascending) {
            sortDirective = "-" + sortDirective;
          }
          $scope.sortDirective = sortDirective;
          $scope.$broadcast(wsEventNames.pager.setPage, 1);
        });
      }
    };
    $scope.fetchPage = function (offset, limit) {
      offset = offset || 0;
      limit = limit || 10;
      var fetchCfg = {
        cardId: $scope.cardId,
        cardToPreview: $scope.cardId === 'preview' ? $scope.card : null,
        params: {
          "_limit": limit,
          "_offset": offset,
          "order_by": $scope.sortDirective
        }
      };
      return Utils.fetchData(fetchCfg).then(function (data) {
        $scope.data = data.results[0].result.data;
        $scope.stats = data.results[0].result.stats;
        var measures = $scope.config.measures;
        var dimensions = $scope.config.dimensions;
        var overlayConfig = $scope.config.overlay,
          overlayData = null,
          overlayStats = null,
          overlayMeasures = null,
          overlayName = null;

        // separate overlayData from returned data
        if (overlayConfig) {
          overlayMeasures = overlayConfig.measures;
          overlayName = overlayConfig.name;
          overlayData = _.map($scope.data, function (dataPt) {
            var overlayPt = {};
            overlayPt.values = angular.copy(dataPt.values);
            // update overlayPt labels to include overlayName prefix
            overlayPt.values[0].label = overlayName + ': ' + overlayPt.values[0].label;
            overlayPt.aggregations = dataPt.aggregations.slice(-overlayMeasures.length);
            dataPt.aggregations = dataPt.aggregations.slice(0, overlayMeasures.length);
            return overlayPt;
          });
          overlayStats = $scope.stats.slice(-overlayMeasures.length);
          $scope.stats = $scope.stats.slice(0, overlayMeasures.length);
        }
        var defaultRange = {
          min: 0
        };
        $scope.chartRange = ChartUtils.getRange($scope.stats, measures, defaultRange);
        $scope.pagenote.setReportMetadata(data);

        //------------------------------------------------
        // set up Average series to put on chart / in grid
        //------------------------------------------------

        if (!$scope.average) {
          $scope.average = {
            name: "Average",
            values: [{
              value: -1,
              label: "Average"
            }],
            aggregations: _.map($scope.stats, function (s) {
              return {
                value: _.isNumber(s.avg) ? parseFloat(s.avg).toFixed(2) : null
              };
            }),
            measures: measures,
            stats: $scope.stats
          };
          $scope.addToChart($scope.average);
        }
        var gridData = [_.extend({
          label: 'Average',
          onChart: true,
          dataPoint: $scope.average
        }, _.object(measureNames, _.chain($scope.average.aggregations).filter(function (a, i) {
          return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
        }).map(function (a, i) {
          return AggUtils.getMeasureValueDisplay(a, measures[i] || 'n/a');
        }).value()))];

        //-----------------------------------------
        // set up overlay Average data (if present)
        //-----------------------------------------

        if (!$scope.overlayAvg && overlayConfig) {
          $scope.overlayAvg = {
            name: overlayName + ' Average',
            values: [{
              value: -2,
              label: overlayName + ' Average'
            }],
            aggregations: _.map(overlayStats, function (s) {
              return {
                value: s.avg
              };
            }),
            measures: overlayMeasures,
            stats: overlayStats
          };
          $scope.addToChart($scope.overlayAvg);
        }

        // add overlay Average data to gridData
        if ($scope.overlayAvg) {
          gridData.push(_.extend({
            label: overlayName + ' Average',
            onChart: true,
            dataPoint: $scope.overlayAvg
          }, _.object(measureNames, _.chain($scope.overlayAvg.aggregations).filter(function (a, i) {
            return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
          }).map(function (a, i) {
            return AggUtils.getMeasureValueDisplay(a, overlayMeasures[i]);
          }).value())));
        }

        //----------------------------------------
        // set up main data Benchmark (if present)
        //----------------------------------------

        if (!$scope.benchmark && Utils.hasBenchmark(measures)) {
          $scope.benchmark = {
            name: 'Benchmark',
            values: [{
              value: -3,
              label: 'Benchmark'
            }],
            aggregations: _.map($scope.config.measures, function (m) {
              return {
                value: m.benchmark && parseFloat(m.benchmark.value) || null
              };
            }),
            measures: measures,
            stats: $scope.stats
          };
          $scope.addToChart($scope.benchmark);
        }

        // add benchmark series to gridData
        if ($scope.benchmark) {
          gridData.push(_.extend({
            label: 'Benchmark',
            onChart: true,
            dataPoint: $scope.benchmark
          }, _.object(measureNames, _.chain(measures).filter(function (m, i) {
            return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
          }).map(function (m) {
            return Math.floor(m.benchmark && parseFloat(m.benchmark.value) * 100) / 100 || null;
          }).value())));
        }

        //---------------------------------------------
        // set up Overlay Benchmark series (if present)
        //---------------------------------------------

        if (!$scope.overlayBenchmark && Utils.hasBenchmark(overlayMeasures)) {
          $scope.overlayBenchmark = {
            name: overlayName + ' Benchmark',
            values: [{
              value: -4,
              label: overlayName + ' Benchmark'
            }],
            aggregations: _.map(overlayMeasures, function (m) {
              return {
                value: m.benchmark && parseFloat(m.benchmark.value) || null
              };
            }),
            measures: overlayMeasures,
            stats: overlayStats
          };
          $scope.addToChart($scope.overlayBenchmark);
        }

        // add benchmark series to gridData
        if ($scope.overlayBenchmark) {
          gridData.push(_.extend({
            label: overlayName + ' Benchmark',
            onChart: true,
            dataPoint: $scope.overlayBenchmark
          }, _.object(measureNames, _.chain(overlayMeasures).filter(function (m, i) {
            return ($scope.config.hiddenMeasures || []).indexOf(i) === -1;
          }).map(function (m) {
            return Math.floor(m.benchmark && parseFloat(m.benchmark.value) * 100) / 100 || null;
          }).value())));
        }

        //----------------------------------------------
        // set up page of data (with overlay if present)
        //----------------------------------------------

        // utility function to build row of table data
        var getRowFromData = function getRowFromData(data, measures, dimensions, stats, hiddenMeasures) {
          var row = _.object(measureNames, _.chain(data.aggregations).map(function (a, i) {
            return AggUtils.getMeasureValueDisplay(a, measures[i] || "n/a");
          }).filter(function (m, i) {
            return (hiddenMeasures || []).indexOf(i) === -1;
          }).value());
          row.label = AggUtils.getDimensionDisplay(data.values[0], dimensions[0]);
          row.onChart = false;
          row.dataPoint = angular.extend({}, data, {
            measures: measures,
            stats: stats
          });
          return row;
        };

        // setup each row as array of [data, overlayData (if present)], then flatten
        var pageData = _.map($scope.data, function (d, i) {
          var row = getRowFromData(d, measures, dimensions, $scope.stats, $scope.config.hiddenMeasures || []);
          if (overlayConfig) {
            var overlay_data = overlayData[i];
            if (overlay_data) {
              return [row, getRowFromData(overlay_data, overlayMeasures, dimensions, overlayStats, $scope.config.hiddenMeasures || [])];
            }
          }
          return [row];
        });
        gridData = gridData.concat(_.flatten(pageData));
        $scope.hasData = $scope.data.length > 0;
        if ($scope.gridOptions) {
          $scope.gridOptions.style.height = "".concat((gridData.length + 1) * gridRowHeight, "px");
          $timeout(function () {
            $scope.gridOptions.data = gridData;
            $scope.gridApi.core.handleWindowResize();
          });
        }
        return data.results[0].result;
      }, function () {
        $scope.hasData = false;
      });
    };
    $scope.subDetails = [{
      text: "Download data",
      downloadData: true,
      tooltip: "Download data tables",
      href: CardQueryResource.getDownloadUrl('spider/csv', $scope.cardId, $scope.config)
    }, {
      text: "Download interaction statements",
      downloadData: true,
      tooltip: "Download interaction statements",
      callback: Utils.getStatementDownloadUrl($scope.cardId === 'preview' ? $scope.config : $scope.cardId)
    }];
    $scope.pagenote = {
      "clearCacheAction": "cards/" + $scope.cardId + "/cache"
    };
    $scope.sortDirective = $scope.sortConfig.sortDirective();
    $timeout(function () {
      $scope.$broadcast(wsEventNames.pager.setPage, 1);
    }, 0);
  }]);
})();
